var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Report',{attrs:{"module":"Estoque","name":"Historico de Patrimonios","urlGet":"/api/v1/stock/report/history-patrimony","header":_vm.header,"filters":_vm.filters}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }